import { prefixZero } from "@covertree/utils";

import { createInput } from "./createInput";

export const Day = createInput({
  sx: (theme) => ({
    width: theme.spacing(10),
    marginLeft: theme.spacing(2),
  }),
  customOnBlur: (e, { zeroPrefixDisabled, updater }) => {
    if (!zeroPrefixDisabled) {
      updater(prefixZero(e.target.value));
    }
  },
  fieldName: "day",
  updaterName: "changeDay",
  maxLength: 2,
});
